import {
  CREATE_SERVICE,
  CREATE_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICES_PAGINATION
} from "../constants/Services";

export const getServices = (page, perPage = 10, search = "") => {
  return {
    type: GET_SERVICES,
    page,
    perPage,
    search
  }
}

export const getServicesSuccess = (services, total, from, to) => {
  return {
    type: GET_SERVICES_SUCCESS,
    services,
    from,
    to,
    total
  }
}

export const createService = (data, history) => {
  return {
    type: CREATE_SERVICE,
    data,
    history
  }
}

export const createServiceSuccess = (service) => {
  return {
    type: CREATE_SERVICE_SUCCESS,
    service
  }
}

export const getService = (id) => {
  return {
    type: GET_SERVICE,
    id
  }
}

export const getServiceSuccess = (service) => {
  return {
    type: GET_SERVICE_SUCCESS,
    service
  }
}

export const updateService = (id, service, history) => {
  return {
    type: UPDATE_SERVICE,
    id,
    service,
    history,
  }
}

export const updateServiceSuccess = (service) => {
  return {
    type: UPDATE_SERVICE_SUCCESS,
    service
  }
}

export const deleteService = (service_id, history) => {
  return {
    type: DELETE_SERVICE,
    service_id,
    history
  }
}

export const deleteServiceSuccess = (service_id) => {
  return {
    type: DELETE_SERVICE_SUCCESS,
    service_id,
  }
}

export const updateServicesPagination = (page, perPage = 10, search = "") => {
  return {
    type: UPDATE_SERVICES_PAGINATION,
    perPage,
    search,
    page
  }
}